import { delay, http, HttpResponse, PathParams } from "msw";

const movies = [
  {
    id: "1",
    title: "Guardians of the Galaxy",
    comment: ""
  },
  {
    id: "2",
    title: "Wall-E",
    comment: ""
  }
];

export const movieHandlers = [
  http.get("/movies", async () => {
    await delay(500);
    return HttpResponse.json({
      ts: Date.now(),
      movies: movies.map(({ id, title }) => ({ id, title }))
    });
  }),

  http.get("/movies/:id", async ({ params }) => {
    const { id } = params;
    const movie = movies.find((movie) => movie.id === id);
    if (!movie) {
      return new HttpResponse(`Movie with id ${id} not found`, {
        status: 404
      });
    }
    await delay(500);
    return HttpResponse.json({ ts: Date.now(), movie });
  }),

  http.post<PathParams, { comment: string }>(
    "/movies/:id",
    async ({ request, params }) => {
      const { id } = params;
      const body = await request.json();
      const { comment } = body;
      movies.forEach((movie) => {
        if (movie.id === id) {
          movie.comment = comment.toUpperCase();
        }
      });
      await delay(500);
      return HttpResponse.json({
        message: `Successfully updated movie ${id}`
      });
    }
  )
];
